import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tw-mb-1 tw-block tw-text-xs dark:tw-text-white"
}
const _hoisted_2 = { class: "tw-w-full tw-rounded-md tw-border tw-bg-white hover:tw-border-deep-orange-500 dark:tw-bg-black" }
const _hoisted_3 = { class: "tw-flex tw-h-10 tw-items-center tw-justify-between tw-border-b tw-p-1" }
const _hoisted_4 = {
  "data-testid": "studio-calendar-month-year-text",
  class: "tw-text-sm dark:tw-text-white"
}
const _hoisted_5 = { class: "tw-grid tw-grid-cols-7 tw-justify-center tw-pt-4 tw-text-center" }
const _hoisted_6 = { class: "tw-grid tw-grid-cols-7 tw-grid-rows-5 tw-pb-3 tw-text-center" }
const _hoisted_7 = ["disabled", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TablerArrowLeft = _resolveComponent("TablerArrowLeft")!
  const _component_TablerArrowRight = _resolveComponent("TablerArrowRight")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          "data-testid": "studio-calendar-arrow-left-button",
          class: "tw-h-full tw-rounded tw-px-4 hover:tw-bg-deep-orange-50",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setPreviousMonth && _ctx.setPreviousMonth(...args)))
        }, [
          _createVNode(_component_TablerArrowLeft, { class: "tw-h-5 tw-w-5" })
        ]),
        _createElementVNode("div", _hoisted_4, _toDisplayString(`${_ctx.MONTHS[_ctx.visibleMonthDate.getMonth()]} ${_ctx.visibleMonthDate.getFullYear()}`), 1),
        _createElementVNode("button", {
          type: "button",
          "data-testid": "studio-calendar-arrow-right-button",
          class: "tw-h-full tw-rounded tw-px-4 hover:tw-bg-deep-orange-50",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setNextMonth && _ctx.setNextMonth(...args)))
        }, [
          _createVNode(_component_TablerArrowRight, { class: "tw-h-5 tw-w-5" })
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.DAYS, (day) => {
          return (_openBlock(), _createElementBlock("div", {
            key: day,
            class: "tw-text-xs tw-font-medium tw-text-deep-orange-500"
          }, _toDisplayString(day), 1))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.datesOfMonth, (date) => {
          return (_openBlock(), _createElementBlock("div", {
            key: date.valueOf(),
            class: "tw-flex tw-h-10 tw-items-center tw-justify-center",
            style: _normalizeStyle({ gridColumnStart: date.getDay() + 1 })
          }, [
            _createElementVNode("button", {
              type: "button",
              "data-testid": "studio-calendar-date-button",
              class: _normalizeClass({
              'tw-flex tw-h-7 tw-w-7 tw-flex-col tw-items-center tw-justify-center tw-rounded-full hover:tw-ring hover:tw-ring-deep-orange-500': true,
              'tw-bg-deep-orange-500': _ctx.isDateSelected(date),
              'tw-ring tw-ring-slate-100 tw-ring-offset-2 tw-ring-offset-white dark:tw-ring-slate-800 dark:tw-ring-offset-black':
                _ctx.isDateToday(date),
              'tw-cursor-not-allowed hover:tw-ring-0': _ctx.isDateDisabled(date)
            }),
              disabled: _ctx.isDateDisabled(date),
              onClick: ($event: any) => (_ctx.selectDate(date))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass({
                'tw-text-sm tw-text-black dark:tw-text-white': true,
                'tw-text-slate-400 dark:tw-text-slate-400': _ctx.isDateDisabled(date),
                'tw-text-white': _ctx.isDateSelected(date)
              })
              }, _toDisplayString(date.getDate()), 3)
            ], 10, _hoisted_7)
          ], 4))
        }), 128))
      ])
    ])
  ]))
}